<template>
  <component
    :is="inertia ? 'inertia-link' : 'b-button'"
    :class="computedClass"
    v-bind="{
      ...$attrs,
      variant,
      size,
    }"
    :data-cy="dataCy"
    @click="onClick"
  >
    <template v-if="!loading">
      <slot v-if="!svgIcon" name="icon">
        <i v-if="icon" :class="[iconName, iconPrefix, iconOpacitySwap, iconClassSize]"></i>
        <i v-if="iconName2" :class="[iconName2, iconPrefix, iconOpacitySwap, iconClassSize]"></i>
      </slot>
      <slot v-else-if="loading" name="svg-icon"></slot>
      <slot name="btnText">{{ btnText }}</slot>
      <i v-if="iconRight" :class="rightIconClassNames"></i>
      <slot></slot>
    </template>
    <template v-else>
      <b-spinner :variant="loadingSpinnerVariant" :class="{ [loadingSpinnerClass]: !!loadingSpinnerClass }" />
    </template>
  </component>
</template>

<script>
  export default {
    name: 'Btn',

    props: {
      loadingSpinnerVariant: { type: String, default: 'primary' },
      size: { type: String, default: 'md' },
      loadingSpinnerClass: String,
      iconRight: Boolean,
      iconName2: String,
      duotone: Boolean,
      inertia: Boolean,
      iconName: String,
      loading: Boolean,
      svgIcon: Boolean,
      btnText: String,
      variant: String,
      dataCy: String,
      small: Boolean,
      icon: Boolean,
      fab: Boolean,
      swapDuotoneOpacity: Boolean,
      iconClassSize: {
        type: String,
        default: '',
      },
      applySameIconPrefixForBothIcons: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      iconPrefix() {
        return this.duotone ? 'fa-duotone' : 'fa';
      },

      iconOpacitySwap() {
        return this.duotone && this.swapDuotoneOpacity ? 'fa-swap-opacity' : '';
      },

      computedClass() {
        return [
          {
            'position-relative': this.loading,
            'btn-fab': this.fab,
          },
          this.inertia ? `btn btn-${this.variant}` : '',
          `btn-${this.size}`,
        ];
      },

      rightIconClassNames() {
        return [
          this.iconName,
          this.applySameIconPrefixForBothIcons ? this.iconPrefix : 'fa',
          'ml-1',
          this.iconOpacitySwap,
          this.iconClassSize,
        ];
      },
    },

    methods: {
      onClick(evt) {
        if (this.loading) return;
        this.$emit('click', evt);
      },
    },
  };
</script>
